// Returns the active element
export const getActiveElement = (): HTMLElement | null => {
    return typeof document !== "undefined" ? (document.activeElement as HTMLElement) : null;
};
